/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelattachlabel2Inputs */

const en_channelattachlabel2 = /** @type {(inputs: Channelattachlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attachment`)
};

const de_channelattachlabel2 = /** @type {(inputs: Channelattachlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anhang`)
};

/**
* | output |
* | --- |
* | "Attachment" |
*
* @param {Channelattachlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelattachlabel2 = /** @type {((inputs?: Channelattachlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelattachlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelattachlabel2(inputs)
	return de_channelattachlabel2(inputs)
});
export { channelattachlabel2 as "channelAttachLabel" }